import { CSSObject } from "styled-components";
import { vfxTheme } from "../common/VFX-UI/Theme/theme";

interface ButtonStyles {
  resendEmailButton: CSSObject;
  resendEmailButtonContainer: CSSObject;
}

const useEmployeeStyles = (): ButtonStyles => {
  
  return {
    resendEmailButton: {
          backgroundColor: vfxTheme.palette.blueGreys.bg500,
          color: vfxTheme.palette.background.default,
          marginLeft: vfxTheme.spaceUnits.sp02,
      display: "flex",
      alignItems: "center",
      fontSize: "1rem",
    },
    resendEmailButtonContainer: {
      marginLeft: "0.5rem",
    },
  };
};

export default useEmployeeStyles;
